import { useEffect } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../components/BannerOne";
import CardsFormatOne from "../../components/CardsFormatOne";
import SignUpBlock from "../../components/SignUpBlock";
import IntroductionBlock from "../../components/IntroductionBlock";
// Constants
import {
  TITLE,
  SUB_TITLE,
  BUTTON_NAME,
  BUTTON_LINK,
  EYE_BROWN_HEADER_CARDS,
  TITLE_CARDS,
  SUB_TITLE_CARDS,
  ALL_CARD_ROWS,
  SPECIALIZATION_BADGES,
} from "./PartnerProgramConstants";
import {
  EYE_BROWN_HEADER,
  CONTENT_BLOCKER_TITLE,
  CONTENT_BLOCKER_SUB_TITLE,
  FRAME_QUOTE,
  QUOTE_SIGN,
  QUOTE_JOB_TITLE,
} from "./PartnerProgramConstants";
import {
  INTRO_EYE_BROWN_HEADER,
  INTRO_TITLE,
  INTRO_TEXT,
  SIGN_UP_TITLE,
  SIGN_UP_SUB_TITLE,
  BANNER_LINK,
  BUTTON_NAME_SIGN_UP,
} from "./PartnerProgramConstants";
// Images
import partnerProgramLogo from "../../assets/img/partnerProgram/banner.png";
import associate from "../../assets/img/partnerProgram/associate.png";
import professional from "../../assets/img/partnerProgram/professional.png";
import foundation from "../../assets/img/partnerProgram/foundation.png";
import serviceEndorsement from "../../assets/img/partnerProgram/serviceEndorsement.png";

// Scss
import "../../assets/css/partnerProgram.scss";
import "../../assets/css/partnerPortal/appDeveloper.scss";
import "../../assets/css/partnerPortal/sales.scss";
import TitleSubTitleCenter from "../../components/TitleSubTitleCenter";
import CardWithNoBorder from "../../components/CardWithNoBorder";

function PartnerProgram() {
  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();
  }, []);

  return (
    <>
      <BannerOne
        bannerImage={partnerProgramLogo}
        title={TITLE}
        subTitle={SUB_TITLE}
        buttonName={BUTTON_NAME}
        buttonLink={BUTTON_LINK}
      />
      <IntroductionBlock
        eyeBrownHeader={INTRO_EYE_BROWN_HEADER}
        title={INTRO_TITLE}
        text={INTRO_TEXT}
      />

      <CardsFormatOne
        eyeBrownHeader={EYE_BROWN_HEADER_CARDS}
        title={TITLE_CARDS}
        subTitle={SUB_TITLE_CARDS}
        cards={ALL_CARD_ROWS}
      />

      <div className="d-flex flex-column align-items-center width64 ml-auto mr-auto margin96Top">
        <TitleSubTitleCenter
          title={CONTENT_BLOCKER_TITLE}
          subTitle={CONTENT_BLOCKER_SUB_TITLE}
          eyeBrownHeader={EYE_BROWN_HEADER}
        />
        <div className="d-flex align-items-center justify-content-center">
          <div className="d-flex flex-column align-items-center justify-content-center backgroundBanner">
            <div className="d-flex flex-column align-items-center justify-content-center backgroundBannerWhite width66">
              <div className="d-flex align-items-start align-items-stretch mb-4 mt-4">
                <div className="QuoteText">{FRAME_QUOTE}</div>
              </div>
              <div className="d-flex flex-column align-items-center width48 mt-4 mb-5">
                <div className="activityDetails2">{QUOTE_SIGN}</div>
                <div className="howSubSection">{QUOTE_JOB_TITLE}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="containerAll margin96Botton">
        <TitleSubTitleCenter
          title={
            "How to get started: The Partner Services Endorsed Observability Process"
          }
          subTitle={
            <div>
              To take part, you must hold your Associate and Professional
              Certifications. It's intended for those experienced with the
              Dynatrace platform, deployments, and customer engagements. If
              you’re not certified yet, it's easy to get started{" "}
              <a href="https://partners.dynatrace.com/#/page/enablement">
                here
              </a>
              .
            </div>
          }
        />

        <div className="w-100 d-flex align-items-center flex-column">
          <div className="FlexToBlock align-items-start w-100">
            <CardWithNoBorder
              link="https://dt-url.net/3z3xxg"
              icon={associate}
              eyeBrow={"STEP 1"}
              title={"Associate"}
              subTitle={"Certification"}
              imageHeight={"162px"}
            />
            <CardWithNoBorder
              link="https://university.dynatrace.com/certification/21971"
              icon={professional}
              eyeBrow={"STEP 2"}
              title={"Professional"}
              subTitle={"Certification"}
              imageHeight={"162px"}
            />
            <CardWithNoBorder
              link="https://university.dynatrace.com/certification/35576"
              icon={foundation}
              eyeBrow={"STEP 3"}
              title={"Services Foundation"}
              subTitle={"Certification"}
              imageHeight={"142px"}
              margin={"10px 0px 10px 0px"}
            />
            <CardWithNoBorder
              link="https://dt-url.net/ux3wd9"
              icon={serviceEndorsement}
              eyeBrow={"STEP 4"}
              title={"Services Endorsed"}
              subTitle={"Endorsement"}
              imageHeight={"162px"}
              maxWidth={"145px"}
            />
          </div>
        </div>
        {/* <ButtonOne
          target="_blank"
          text={"Get started"}
          classNameOfA={"width13"}
          className={"pad7"}
          link="https://dt-url.net/ux3wd9"
          withoutIcon={true}
        /> */}
      </div>

      <div className="d-flex flex-column align-items-center width67 mx-auto ">
        <div className="d-flex flex-column align-items-center width63 mb-2 ">
          <div className="d-flex align-items-center align-self-stretch textStyle colorBlack m-auto pb-3 text-center">
            Services Program Specializations Available
          </div>
          <div className="introframeSubText text-center m-auto">
            Build on the Observability Certification with specializations that
            will help develop your integration, automation, and development
            expertise.
          </div>
        </div>
        {/* <div className="align-items-start d-flex justify-content-center flex-wrap">
          {SERVICES_PROGRAM_CONTENT.map((content, i) => (
            <div
              key={i}
              className="d-flex flex-column align-items-center cardBackground width46 mr-4 mb-4"
            >
              <img src={appDeveloper} width={"100%"} />
              <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                <div className="d-flex flex-column align-items-center align-self-stretch mb-4">
                  <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">
                    {content.title}
                  </div>
                </div>
                <ButtonArrow
                  link={content.link}
                  target="_parent"
                  buttonName={"Learn More"}
                  width="15%"
                />
              </div>
            </div>
          ))}
        </div> */}
      </div>
      <div className="containerAll margin96Botton">
        {/* <TitleSubTitleCenter
          title={"Dynatrace Services Specializations Roadmap"}
          subTitle={
            "See what we've got in store to help take your development and expertise to the next level."
          }
        /> */}

        <div className="w-100 d-flex justify-content-center flex-wrap">
          {SPECIALIZATION_BADGES.filter((x) => x.icon).map((badge, i) => (
            <CardWithNoBorder
              key={i}
              icon={badge.icon}
              eyeBrow={badge.eyebrow}
              title={badge.title}
              subTitle={badge.subTitle}
              imageWidth={badge.imageWidth}
              link={badge.link}
              linkOpenSamePage={badge.linkOpenSamePage}
              linkForTitle={badge.linkForTitle}
            />
          ))}

          {/* <CardWithNoBorder
            link={"https://partners.dynatrace.com/#/page/app-developer"}
            icon={appDeveloperBadge}
            eyeBrow={""}
            title={"Available now"}
            subTitle={""}
          />
          <CardWithNoBorder
            link={"https://partners.dynatrace.com/#/page/saas-migration"}
            icon={dynatraceMigrationBadge}
            eyeBrow={""}
            title={"Available now"}
            subTitle={""}
          /> */}
        </div>
      </div>

      <SignUpBlock
        title={SIGN_UP_TITLE}
        subTitle={SIGN_UP_SUB_TITLE}
        bannerLink={BANNER_LINK}
        buttonName={BUTTON_NAME_SIGN_UP}
      />
    </>
  );

  function canYouHaveAccess() {
    try {
      if (
        process.env.REACT_APP_PROTECT_PAGE === "true" &&
        window.top?.location.host !== process.env.REACT_APP_ALLOW_API
      ) {
        console.log("You shall not pass");
        history.push("/not-found");
      }
    } catch (err) {}
  }
}

export default PartnerProgram;
